module.exports = __webpack_public_path__ + "img/BetterCriticals.54f0530d.png";